class CustomForm extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.init();
    }

    init() {
        this.form = this.querySelector('form');

        if (!this.form) throw new Error("Couldn't find form", this);

        this.submitURL = this.dataset.url;

        if (!this.submitURL) {
            this.submitURL = this.form.action;
        }

        if (!this.submitURL) throw new Error("Coulndn't find submit URL", this);

        this.formStateEl = this.querySelector('[data-form-state]');
        this.completedStateEl = this.querySelector('[data-completed-state]');
        this.submitButton = this.querySelector('button[type="submit"]');

        this.addEventListeners();
    }

    addEventListeners() {
        if (this.completedStateEl) {
            this.showFormHandler = this.showForm.bind(this);

            this.completedStateEl.addEventListener('click', this.showFormHandler);
        }

        this.submitHandler = this.handleSubmit.bind(this);

        this.addEventListener('submit', this.submitHandler);
    }

    showForm() {
        this.formStateEl.classList.remove('hidden');
        this.completedStateEl.classList.add('hidden');
    }

    showCompleted() {
        this.formStateEl.classList.add('hidden');
        this.completedStateEl.classList.remove('hidden');
        this.completedStateEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    async handleSubmit(evt) {
        evt.preventDefault();

        this.submitForm();
    }

    async submitForm() {
        const formData = new FormData(this.form);
        this.setErrorMsgState();

        this.submitButton.classList.add('btn-loading');

        try {
            const response = await fetch(this.submitURL, {
                method: 'POST',
                body: formData
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const result = await response.json();
            console.log('Form submitted successfully:', result);

            this.form.reset();
            this.showCompleted();
        } catch (error) {
            console.error('Error submitting form:', error);
            this.setErrorMsgState(error);
        }

        this.submitButton.classList.remove('btn-loading');
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
        this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
        if (!this.errorMsg) return;

        this.errorMsg.classList.toggle('hidden', !error);
        if (error) this.errorMsg.textContent = error;
    }
}

customElements.define('custom-form', CustomForm);
